import Splide from '@splidejs/splide'

export function initSingleCompany() {
    const singleCompany = document.querySelector('.singleCompany')
    if (singleCompany) {
        setupSingleCompany(singleCompany)
    }
}

function setupSingleCompany(singleCompany) {
    const media = singleCompany.querySelector('.singleCompany-media-gallery'),
        forms = [].slice.apply(singleCompany.querySelectorAll('.singleCompany-form'))

    if (media) {
        const isSingle = media.querySelectorAll('.splide__slide').length === 1
        let slider = new Splide(media, {
            arrows: !isSingle,
            pagination: !isSingle,
            drag: !isSingle,
            height: '58vh',
            autoHeight: true,
        })

        slider.mount()
    }

    if (forms) {
        forms.forEach(form => {
            const productsWrapper = form.querySelector('.wpcf7-products-wrapper')

            form.querySelector('.singleCompany-form-top').addEventListener('click', () => {
                jQuery(form.querySelector('.singleCompany-form-cf7')).fadeToggle(250)
                form.classList.toggle('open')
            })

            if (productsWrapper) {
                let products = []
                const selects = productsWrapper.querySelectorAll('.wpcf7-products-product-select')
                productsWrapper.querySelector('.wpcf7-products-order-submit').addEventListener('click', () => {
                    products = [].slice.apply(selects).map(select => {
                        return select.value
                    })

                    form.querySelector('#product-list').value = products.join(', ')

                    productsWrapper.querySelector('.wpcf7-products-cart-order').innerHTML = products.join('<br>')
                    productsWrapper.querySelector('.wpcf7-products-cart').classList.add('show')
                })
            }
        })
    }
}

